module.exports = __webpack_public_path__ + "static/media/Business-Card-Design_ChooMayKuen.a9d01e95.jpg";